







































































import {
  defineComponent,
  reactive,
  ref,
  watch,
  computed,
} from '@vue/composition-api'
// import moment from 'moment'
import { VueLoading } from 'vue-loading-template'
import moment from 'moment'

import { UserState, SpecialOfferReceiptState } from '@/types/store'

import useVuex from '@/utils/useVuex'

import { SpecialOfferReceiptView } from '@/components/molecules'
import Layout from '@/components/organisms/common/Layout.vue'
import SpecialOfferTable from '@/components/organisms/special-offer-receipts/SpecialOfferTable.vue'
import SpecialOfferReceiptFormTable from '@/components/organisms/special-offer-receipts/SpecialOfferReceiptFormTable.vue'
import SpecialOfferReceiptActions from '@/components/organisms/special-offer-receipts/SpecialOfferReceiptActions.vue'
import { getSlog } from '@/utils/changeReceiptStatus'
import { ISpecialOfferReceipt } from '@/types/special-offer'

export default defineComponent({
  name: 'CheckSpecialOfferReceipt',
  components: {
    SpecialOfferReceiptView,
    Layout,
    VueLoading,
    SpecialOfferTable,
    SpecialOfferReceiptFormTable,
    SpecialOfferReceiptActions,
  },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      specialOfferReceipt: useVuex<
        SpecialOfferReceiptState['specialOfferReceipt']
      >(
        context,
        () => store.getters['specialOfferReceipt/specialOfferReceipt'],
      ),
      receiptType: useVuex<SpecialOfferReceiptState['receiptType']>(
        context,
        () => store.getters['specialOfferReceipt/receiptType'],
      ),
      workStartedMoment: moment(),
      loading: false,
    })
    // For dynamic receipt view height
    const receiptViewHeight = ref<number>(0)
    const changeReceitViewHeight = () => {
      setTimeout(() => {
        const rightCol = document.querySelector('.SpecialOfferReceipt_RightCol')
        receiptViewHeight.value = rightCol ? rightCol.scrollHeight - 76 : 0
      }, 100)
    }
    watch([() => state.specialOfferReceipt?.id], () => {
      state.workStartedMoment = moment() // for logger
      if (state.specialOfferReceipt !== null) {
        state.loading = false
        changeReceitViewHeight()
      }
    })
    changeReceitViewHeight()

    const finishSpecialOfferReceipt = async () => {
      let needsLeaderCheck =
        state.specialOfferReceipt.specialOffer.needsLeaderCheck
      if (needsLeaderCheck && state.specialOfferReceipt.itemName) {
        needsLeaderCheck = state.specialOfferReceipt.specialOffer.itemNames.includes(
          state.specialOfferReceipt.itemName,
        )
      }
      if (needsLeaderCheck && state.specialOfferReceipt.chainStoreName) {
        needsLeaderCheck = state.specialOfferReceipt.specialOffer.chainStoreNames.includes(
          state.specialOfferReceipt.chainStoreName,
        )
      }
      await store.dispatch('specialOfferReceipt/updateSpecialOfferReceipt', {
        id: state.specialOfferReceipt.id,
        dto: {
          chainStoreName: state.specialOfferReceipt.chainStoreName,
          storeName: state.specialOfferReceipt.storeName,
          phone: state.specialOfferReceipt.phone,
          dateTime: state.specialOfferReceipt.dateTime,
          itemName: state.specialOfferReceipt.itemName,
          itemNameSecond: state.specialOfferReceipt.itemNameSecond,
          sum: state.specialOfferReceipt.sum,
          ngReason: state.specialOfferReceipt.ngReason,
          needsLeaderCheck,
        },
        userRole: state.user?.role,
        userId: state.user?.id,
      })
      if (state.user !== null && state.specialOfferReceipt !== null) {
        const user = state.user
        const specialOfferReceipt = (state.specialOfferReceipt as unknown) as ISpecialOfferReceipt
        const now = moment()
        const log = getSlog(specialOfferReceipt, state.receiptType)
        await store.dispatch('slog/createLog', {
          castId: user.castId,
          castName: user.castName,
          workerType: user.role,
          workedAt: now.toDate(),
          workDuration: now.diff(state.workStartedMoment, 'seconds'),
          workTarget: log[0],
          workResult: log[1],
          note: '',
          specialOfferReceiptId: specialOfferReceipt.id,
          workedById: user.id,
        })
      }
    }

    const updateSpecialOfferReceipt = (
      specialOfferReceipt: SpecialOfferReceiptState['specialOfferReceipt'],
    ) => {
      state.specialOfferReceipt = { ...specialOfferReceipt }
    }

    const onClickFinishWithSave = async () => {
      state.loading = true
      try {
        await finishSpecialOfferReceipt()
        context.root.$router.push('/').catch(() => {
          /*2連打した際のerrorを無視*/
        })
      } catch (error) {
        console.error(error)
      }
    }
    const onClickFinishWithoutSave = () => {
      context.root.$router.push('/').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }
    const onClickGoBackWithoutSave = () => {
      context.root.$router.go(-1)
    }

    const isLast = computed(
      () => store.getters['specialOfferReceipt/nextReceiptId'] === null,
    )

    const onClickNext = async () => {
      state.loading = true
      try {
        await finishSpecialOfferReceipt()
        if (!isLast.value) {
          const nextReceiptId =
            store.getters['specialOfferReceipt/nextReceiptId']
          await store.dispatch(
            'specialOfferReceipt/getSpecialOfferReceipt',
            nextReceiptId,
          )
          state.loading = false
        } else {
          context.root.$router.go(-1)
        }
      } catch (error) {
        console.error(error)
      }
    }

    return {
      state,
      receiptViewHeight,
      updateSpecialOfferReceipt,
      onClickFinishWithSave,
      onClickFinishWithoutSave,
      onClickGoBackWithoutSave,
      isLast,
      onClickNext,
    }
  },
})
